export enum InspectionType {
  GroundBasedLowRes = 'GroundBasedLowRes',
  GroundBasedHighRes = 'GroundBasedHighRes',
  RopeAccess = 'RopeAccess',
  DroneOrHelicopter = 'DroneOrHelicopter',
  Aether = 'Aether',
  Unknown = 'Unknown',
  NoMetadata = 'NoMetadata',
  Telescope = 'Telescope'
}
